import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { PressRoomComponent } from './press-room.component'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
  ],
  declarations: [PressRoomComponent],
  exports: [PressRoomComponent],
})
export class PressRoomModule {}
